import type { DiagramDoc } from "@fullsteps/shared";
import { el } from "../render/svg.js";
import { modal } from "../editor/modal.js";
import { downloadBlob, downloadText } from "./download.js";
import { buildExportHtml } from "./html.js";
import { svgToPngBlob } from "./png.js";
import { renderStandaloneSvg } from "./standalone.js";

const base = (doc: DiagramDoc): string =>
  (doc.meta.title || "diagramma").toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "");

export function exportHtml(doc: DiagramDoc): void {
  downloadText(`${base(doc)}.html`, buildExportHtml(doc), "text/html;charset=utf-8");
}
export function exportSvg(doc: DiagramDoc): void {
  downloadText(`${base(doc)}.svg`, renderStandaloneSvg(doc).svg, "image/svg+xml;charset=utf-8");
}
export async function exportPng(doc: DiagramDoc): Promise<void> {
  const { svg, width, height } = renderStandaloneSvg(doc);
  downloadBlob(`${base(doc)}.png`, await svgToPngBlob(svg, width, height));
}

export function openExportModal(root: HTMLElement, doc: DiagramDoc): void {
  const { body, close } = modal(root, "Esporta diagramma");
  const opt = (title: string, desc: string, run: () => void | Promise<void>): void => {
    const b = el("button", "exp-opt") as HTMLButtonElement;
    b.type = "button";
    b.appendChild(el("div", "exp-title", title));
    b.appendChild(el("div", "exp-desc", desc));
    b.addEventListener("click", async () => {
      b.classList.add("busy");
      try {
        await run();
        close();
      } catch (e) {
        b.appendChild(el("div", "login-err", e instanceof Error ? e.message : "errore"));
        b.classList.remove("busy");
      }
    });
    body.appendChild(b);
  };
  opt("HTML interattivo", "File autosufficiente e offline: filtri, zoom, temi e pannello dettaglio, come l'originale.", () => exportHtml(doc));
  opt("SVG", "Immagine vettoriale del diagramma completo, con font incorporati.", () => exportSvg(doc));
  opt("PNG", "Immagine raster ad alta risoluzione del diagramma completo.", () => exportPng(doc));
}
